import { DispositionsFormType } from '@mark43/cad-api';
import { useForm } from 'react-hook-form';
import { IntegratedFormProvider } from '../../forms/integrated-form-provider';
import { FR_EVENT_DETAILS_TABS } from '../../fr-event-details-page/constants';
import { useOpenFrEventDetails } from '../../fr-event-details-page/hooks/use-open-fr-event-details';
import { UPDATE_DISPOSITION_DEFAULT_FORM_VALUES } from '../../dispositions/constants';
import { useDispositionQuery } from '../../dispositions/hooks/use-disposition-query';
import { useUpdateDispositionMutation } from '../../dispositions/hooks/use-update-disposition-mutation';

interface FrEditDispositionContainerProps {
    children: React.ReactNode;
    eventId: number;
}

export function FrEditDispositionContainer(props: FrEditDispositionContainerProps) {
    const { children, eventId } = props;
    const openFrEventDetails = useOpenFrEventDetails();

    const dispositionForm = useForm<DispositionsFormType>({
        defaultValues: {
            ...UPDATE_DISPOSITION_DEFAULT_FORM_VALUES,
        },
    });

    const dispositionQuery = useDispositionQuery({ agencyEventId: eventId });

    // Editing the disposition of an already-cleared event only updates dispositions —
    // it does not re-clear the event or release any unit, so we don't need to pass unitIds.
    const updateDispositionMutation = useUpdateDispositionMutation({
        actingTransitioner: 'FIRST_RESPONDER',
        onMutationSuccess: () => {
            openFrEventDetails(eventId, FR_EVENT_DETAILS_TABS.NARRATIVE);
        },
    });

    return (
        <IntegratedFormProvider
            query={dispositionQuery}
            mutation={updateDispositionMutation}
            form={dispositionForm}
        >
            {children}
        </IntegratedFormProvider>
    );
}
